import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const savedLang = localStorage.getItem("lang") || "ru";

const resources = {
  ru: {
    translation: {
      menu: {
        title: "Меню",
        home: "Главная",
        tarifs: "Тарифы",
        info: "Информация",
        funding: "Что такое фандинг?",
        instruction: "Всё о боте",
        markets: "Поддерживаемые биржи",
        faq: "FAQ",
        fundingRates: "Спреды фандинга"
      },
      navbar: {
        trade: "Торговля",
        spreads: "Спреды",
        subscription: "Подписка",
        info: "Информация"
      },
      bell: {
        futuresThreshold: "Порог для фьючерсов (%)",
        spotThreshold: "Порог для спот/фьючерсов (%)",
        dexThreshold: "Порог для DEX (%)",
        blacklist: "Чёрный список",
        thresholdPlaceholder: "Напр. 5",
        thresholdPlaceholder10: "Напр. 10",
        thresholdPlaceholder5: "Напр. 5"
      },
      spreads: {
        entry: "Вход",
        funding: "Фандинг",
        auto: "Авто",
        entryGt0: "Вход > 0",
        back: "⬅ Назад",
        trade: "Торговля",
        noData: "Нет спредов для отображения.",
        noSub: "У вас нет активной подписки.",
        noSubDesc: "Для продолжения работы вам необходимо оплатить подписку.",
        subscription: "Подписка",
        dataUnavailable: "Данные недоступны.",
        noDataForPair: "Нет данных для этой пары.",
        noSubActive: "Нет активной подписки.",
        searching: "Поиск...",
        coinNotFound: "Монета не найдена",
        backToList: "Назад к списку",
        exit: "Выход",
        volume24: "Объём",
        price: "Цена",
        current: "Текущая",
        spreadEntry: "Спред входа",
        contract: "Контракт",
        dexLink: "Ссылка",
        searchPlaceholder: "Поиск монеты...",
        futuresFutures: "Фьючерс/Фьючерс",
        spotFutures: "Спот/Фьючерс",
        coinInput: "Введите монету (BTC, ETH...)",
        volume: "Объём",
        loading: "Загрузка...",
        connect: "Подключение…"
      },
      trade: {
        futuresFutures: "Фьючерс/Фьючерс",
        spotFutures: "Спот/Фьючерс",
        coinInput: "Введите монету (BTC, ETH...)",
        coinInput2: "Введите монету 2 (BTC, ETH...)",
        placeholder: "Введите монету (BTC, ETH...)",
        volume: "Объём",
        loading: "Загрузка...",
        noSubTitle: "У вас нет активной подписки.",
        noSubDesc: "Для продолжения работы вам необходимо оплатить подписку.",
        subscription: "Подписка",
        connect: "Подключение…",
        dexMarket: "DEX",
        market1: "Биржа 1",
        market2: "Биржа 2"
      },
      subscription: {
        title: "Моя подписка",
        active: "Активна",
        inactive: "Неактивна",
        remaining: "Осталось:",
        payBtn: "Оплатить подписку",
        myReferral: "Моя реферальная ссылка",
        referralDesc: "Партнерское вознаграждение начисляется с каждой оплаты подписки вашими рефералами, либо продления, в размере 20% от стоимости подписки.",
        copy: "Копировать",
        copied: "Скопировано!",
        invitedUsers: "Приглашенные пользователи",
        test: "Тест",
        subscribe: "Подписка",
        noInvited: "Нет приглашенных пользователи",
        withdrawInfo: "Для вывода средств напишите сообщение в техподдержку @xWHOxAMxIx с указанием реквизитов для получения.",
        withdrawNote: "Заявки на вывод средств обрабатываются в течении 48 часов.",
        paymentTitle: "Оплата подписки",
        network: "Сеть",
        price: "Цена",
        address: "Адрес для перевода:",
        memo: "Memo (обязательно указывать):",
        paymentNote: "Оплата будет подтверждена автоматически. Если у вас возникнут вопросы или нужны другие способы оплаты — напишите в поддержку:"
      },
      seo: {
        home_title: "FundingRadar | Арбитраж фандинга",
        home_desc: "FundingRadar — уникальный Telegram бот для арбитража фандинга, трейдинга и работы со спредами. Удобный бот для арбитража прямо в Telegram Mini App.",
        faq_title: "FundingRadar | FAQ",
        faq_desc: "Ответы на популярные вопросы о подписке, оплате и работе бота.",
        pricing_title: "FundingRadar | Тарифы",
        pricing_desc: "FundingRadar — уникальный Telegram бот для арбитража фандинга, трейдинга и работы со спредами. Удобный бот для арбитража прямо в Telegram Mini App.",
        markets_title: "FundingRadar | Поддерживаемые биржи"
      },
        banner: {
        title: "ФАНДИНГ БОТ",
        subtitle: "не имеющий аналогов!",
        buy: "Купить подписку",
        consult: "Консультация"
      },
      landing: {
        title: "Профессиональный инструмент для арбитража фандинга между CEX и DEX биржами",
        lead: "Мониторьте ставки фандинга и ловите выгодные связки между биржами — зарабатывайте на разнице ставок и курса без всяких проблем. Поддержка Hyperliquid и популярных CEX.",
        point1: "Мгновенные сигналы — данные каждые 100 мс",
        point2: "Поддержка Hyperliquid, Binance, Bybit, Mexc, Gateio, LBank и других бирж",
        point3: "Всё в Telegram-боте — никаких API и сложных настроек",
        trial: "6 часов бесплатно",
        ask: "Задать вопрос",
        supportTitle: "Поддержка и обучение",
        supportText: "Подробные подсказки в интерфейсе, обучающие материалы и закрытый чат для пользователей — помогаем понять и применять стратегии арбитража фандинга.",
        carouselLabel: "Скриншоты приложения",
        dotsLabel: "Точки слайдера",
        dotAria: "Перейти к слайду {{i}}",
        screens: { 1: "График реального времени", 2: "Исторический график спреда", 3: "Связки спот/фьючерс", 4: "Связки по одной монете", 5: "Связка" },
        whyTitle: "Почему выбирают FundingRadar",
        ctaTitle: "Попробуйте FundingRadar бесплатно",
        ctaText: "Тестовый период — 6 часов. Получите доступ ко всем функциям и начните арбитраж фандинга уже сегодня.",
        tryNow: "Попробовать сейчас"
      },
      benefits: {
        speed: "Мгновенные сигналы",
        speedText: "Обновления каждые 100 мс — вы видите возможности первыми.",
        exchanges: "Поддержка CEX + DEX",
        safety: "Безопасность",
        safetyText: "Никаких подключений к вашим счетам — бот не держит средств и работает в ручном режиме.",
        support: "Обучение и сообщество",
        supportText: "Гайды, кейсы и закрытый чат для пользователей — помогаем быстрее начать и масштабировать.",
        seoText: "FundingRadar — сканер арбитража фандинга. Наш сервис отслеживает ставку финансирования и спреды между биржами (CEX и DEX(Hyperliquid)), показывает где выгодно купить/продать и сколько можно заработать на разнице. Арбитраж фандинга, просмотр истории спредов, лучшие оповещения новых связок — всё это в одном инструменте для трейдеров и арбитражников.",
        exchangesText: "Hyperliquid, Binance, Bybit, Kucoin, Mexc, LBank, Gateio, Bitget и т.д. — все площадки в одном сканере."
      },
      landingProduct: {
        title: "Арбитраж Фьючерсов и заработок на разнице курсов",
        description: "Данный вид арбитража пришел на смену межбиржевого арбитража (где покупали на одной бирже и продавали на другой) и P2P арбитража, и вся работа идет без карт. Для работы вам нужен USDT. Мы работаем только с топовыми биржами и отслеживаем разницу по разным фильтрам. Поддерживаем спот+фьючи, фьючи+фьючи. Сервис покажет, где лучше купить токен, где встать в шорт, покажет объем, историю спреда связки и ставку фандинга для дополнительного дохода. На сегодняшний день это самый прибыльный вид арбитража. Наши клиенты в круг ловят спреды по 5-25%, и в месяц публично зарабатывали от 30% от всего капитала. Результаты смотрите в кейсах.",
        button: "Подробнее о продукте",
        subImage1Alt: "Пример 1",
        subImage2Alt: "Пример 2",
        case: "Пример кейса клиента: при резком росте/падении, а так же на листингах, образуется разница между фьючерс+фьючерс или спот+фьючерс. Клиент открыл лонг по 0.1332$ и тут же поставил шорт на другой бирже по 0.1402$. Через 9 минут цены сошлись и клиент заработал 70$ — это выше, чем обычный стейкинг USDT, темболее практически без рисков.",
        mainImageAlt: "Арбитраж Фьючерсов"
      },
      pricing: {
        title: "Выбери свой тариф",
        tryBtn: "Попробовать",
        month1: {
          title: "1 месяц",
          oldPrice: "$70",
          newPrice: "$40",
          features: [
            "Доступ ко всем функциям FundingRadar",
            "Быстрый поиск лучших спредов",
            "Поддержка спота и фьючерсов",
            "Мгновенные уведомления в Telegram",
            "Реальные графики истории спредов",
            "Доступ к приватному чату",
            "Обучающие материалы с примерами стратегий",
            "Идеально, чтобы протестировать и оценить результаты",
            "Самый дешевый тариф среди конкурентов"
          ]
        },
        month3: {
          badge: "🔥 Самый выгодный тариф",
          title: "3 месяца",
          oldPrice: "$180",
          newPrice: "$75",
          discount: "Экономия 40%",
          features: [
            "Полный доступ без ограничений",
            "Быстрый поиск лучших спредов",
            "Поддержка спота и фьючерсов",
            "Мгновенные уведомления в Telegram",
            "Реальные графики истории спредов",
            "Доступ к приватному чату",
            "Обучающие материалы с примерами стратегий",
            "Экономия 40% и стабильный доступ",
            "Идеальный выбор для активных трейдеров"
          ]
        }
      },
      testimonials: {
        title: "Почему FundingRadar — лучший сканер для арбитража криптовалют",
        chatLabel: "Закрытый чат клиентов",
        prev: "Предыдущий отзыв",
        next: "Следующий отзыв",
        dotsLabel: "Переключение отзывов",
        dotAria: "Перейти к отзыву {{i}}",
        items: [
          {
            imgAlt: "Фото клиента 1",
            title: "За день +33$, сабку отбил",
            text: "Зашел еще раз на традор, крч дважды фандинг забрал по 2 процента в конце сошлась, ну в общем в плюс получилось закрыть, за сегодня +33, сабку отбил)",
            author: "Ulan, клиент"
          },
          {
            imgAlt: "Фото клиента 2",
            title: "Заработал +530$ за 1 день!",
            text: "+530$ (общий за все сделки). Не побил рекорд за день, ну да ладно",
            author: "ORERT, трейдер"
          },
          {
            imgAlt: "Фото клиента 3",
            title: "Отзыв о нашем бесплатном обучении",
            text: "Напиши в личку. Реально , стоит! Все предельно точно , на все(!) вопросы ответит и за руку проведет.",
            author: "E//2, арбитражник"
          }
        ]
      },
      trial: {
        title: "Хотите проверить, как он работает?",
        lead: "Напишите в поддержку, и мы дадим вам тестовый доступ на 6 часов.",
        note: "Также вы можете зайти на наш Telegram-канал и посмотреть результаты наших клиентов.",
        telegramText: "Открыть канал",
        button: "6 часов бесплатно",
        contactSupport: "Написать в поддержку",
        emailSubject: "Запрос тестового доступа",
        telegramUrl: "https://t.me/fundingradar_official",
        fundingBotUrl: "https://t.me/funding_cryptoprojects_bot",
        supportUrl: "https://t.me/xWHOxAMxIx",
        imageAlt: "Иллюстрация робота"
      },
      affiliate: {
        title: "Вы блогер и хотите заработать на партнерской программе?",
        subtitle: "Мы готовы платить до 50% с каждой продажи.",
        description: "Самая щедрая партнерская программа. Если вы имеете свой YouTube, Telegram-канал, сайт, блог и т.д. — мы предлагаем вам партнерскую систему работы. Свяжитесь с нами в Telegram @xWHOxAMxIx",
        button: "Связаться в Telegram",
        imageAlt: "Партнерская программа FundingRadar"
      },
      infoPage: {
        title: "Информация",
        description: "На данной странице вы сможете найти всю необходимую информацию о нашем боте арбитража фандинга.",
        ourSite: "Наш сайт",
        ourChannel: "Наш канал",
        usefulLinks: "Полезные ссылки",
        support: "Техподдержка",
        whatIsFunding: "Что такое фандинг?",
        botGuide: "Инструкция по боту",
        popularQuestions: "Популярные вопросы"
      },
            topFunding: {
        title: "Топ-16 монет по фандингу",
        subtitle: "Актуальные ставки финансирования между биржами",
        fundingDiff: "Разница",
        info: "Обновляется каждые 10 секунд. Значения фандинга — актуальные ставки за период.",
        lastUpdate: "Последнее обновление",
        futuresTitle: "Фьючерсы",
        spotTitle: "Спот/Фьючерсы"
      },
      social: {
        title: "Если у вас остались вопросы, мы с радостью на них ответим",
        sub: "Подпишитесь на наши соц сети, чтобы получить 6 часов бесплатно.",
        buttons: {
          telegram: "Telegram канал",
          support: "Поддержка",
          youtube: "YouTube",
          privateChat: "Закрытый чат"
        },
        disclaimer: "ВАЖНО! Мы не только разработчики программного обеспечения, но и трейдеры. Поэтому наш бот разработан с максимальной надежностью и стабильностью. Мы не даем рекомендации и обещания по заработку, не советуем вам куда-то вкладывать свои деньги и ни в коем случае не работаем с вашими деньгами. Наш софт полностью ручной, все ваши деньги только под вашим личным управлением. Мы приводим примеры, как на арбитраже в прошлом заработали наши клиенты, но мы не советуем повторять действия один в один. Ваш заработок зависит исключительно от ваших действий и от факторов рынка. Команда FundingRadar не несет ответственность за ваши результаты.",
        telegramUrl: "https://t.me/fundingradar_official",
        supportUrl: "https://t.me/xWHOxAMxIx",
        youtubeUrl: "https://www.youtube.com/@fundingradar",
        privateChatUrl: "https://t.me/+iIBEKxXveOMwYjRi",
        imageAlt: "Иллюстрация: следите в соц сетях"
      },
      faq: {
        title: "Часто задаваемые вопросы",
        subtitle: "Ответы на популярные вопросы о подписке, оплате и работе бота.",
        q1: "Сколько стоит подписка?",
        a1: "Стоимость подписки составляет 40 USDT в месяц (30 дней) или 75 USDT за 3 месяца (90 дней).",
        q2: "Как протестировать бота?",
        a2: "Чтобы протестировать бота и убедиться в его работе, пожалуйста, свяжитесь с поддержкой.",
        q3: "Как оплатить подписку?",
        a3: "Чтобы оплатить подписку, переведите средства на реквизиты, указанные в боте. Если этот способ вам не подходит, свяжитесь с нашей технической поддержкой для альтернативных вариантов.",
        q4: "Актуален ли арбитраж фандинга?",
        a4: "Безусловно, арбитраж фандинга остаётся актуальным. При правильном подходе и анализе рыночных условий есть возможность заработать на разнице ставок.",
        q5: "Какие биржи поддерживаются?",
        a5: "Поддерживаются (20 бирж): Bybit, Mexc, Kucoin, Gateio, Bitget, Huobi, Okx, BingX, Binance, BitMart, Ourbit, Hyperliquid, LBank, Aster, XT, CoinEx, WEEX, Phemex, BinanceAlpha, Dex (Hyperliquid).",
        q6: "Как зарабатывать на боте?",
        a6: "Ознакомьтесь с нашими статьями и подробной инструкцией по боту — там описаны все этапы настройки. При необходимости техническая поддержка поможет.",
        q7: "Сколько я смогу заработать?",
        a7: "Точную прибыль предсказать нельзя: многое зависит от рынка, стратегий и уровня риска. Исторические результаты варьируются, примерно от 30% до 100%+ в месяц.",
        q8: "Смогу ли я потерять весь свой депозит?",
        a8: "Теоретически возможно, но при грамотном управлении арбитраж фандинга считается относительно низкорисковым. Типичный убыток по связке — порядка 0–5% депозита.",
        q9: "Здесь нет нужного мне ответа",
        a9: "Свяжитесь с техподдержкой, чтобы получить ответ на ваш вопрос.",
        still_need_help: "Не нашли ответ?",
        contact_support: "Связаться с поддержкой"
      },
      
      markets: {
        title: "Список поддерживаемых криптобирж",
        subtitle: "В данном разделе представлен список CEX бирж (19), которые поддерживает наш сканер.",
        columns: {
          name: "Название",
          taker: "Комиссия тейкера",
          maker: "Комиссия мейкера",
          activeSince: "Активна с"
        },
        items: {
          bybit: {
            name: "Bybit",
            logo: "/images/markets/bybit.png",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2018"
          },
          mexc: {
            name: "Mexc",
            logo: "/images/markets/mexc.jpeg",
            taker: "0.0%",
            maker: "0.0%",
            activeSince: "2018"
          },
          kucoin: {
            name: "Kucoin",
            logo: "/images/markets/kucoin.png",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2017"
          },
          gateio: {
            name: "Gateio",
            logo: "/images/markets/gate.jpeg",
            taker: "0.2%",
            maker: "0.2%",
            activeSince: "2013"
          },
          bitget: {
            name: "Bitget",
            logo: "/images/markets/bitget.jpeg",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2018"
          },
          huobi: {
            name: "Huobi",
            logo: "/images/markets/htx.png",
            taker: "0.2%",
            maker: "0.2%",
            activeSince: "2013"
          },
          okx: {
            name: "Okx",
            logo: "/images/markets/okx.png",
            taker: "0.1%",
            maker: "0.08%",
            activeSince: "2017"
          },
          bingx: {
            name: "BingX",
            logo: "/images/markets/bingx.jpeg",
            taker: "0.020%",
            maker: "0.045%",
            activeSince: "2018"
          },
          binance: {
            name: "Binance",
            logo: "/images/markets/binance.jpeg",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2017"
          },
          bitmart: {
            name: "BitMart",
            logo: "/images/markets/bitmart.png",
            taker: "0.06%",
            maker: "0.04%",
            activeSince: "2017"
          },
          ourbit: {
            name: "Ourbit",
            logo: "/images/markets/ourbit.png",
            taker: "0.04%",
            maker: "0.02%",
            activeSince: "2018"
          },
          hyperliquid: {
            name: "Hyperliquid",
            logo: "/images/markets/hyperliquid.png",
            taker: "0.25%",
            maker: "0.2%",
            activeSince: "2022"
          },
          lbank: {
            name: "LBank",
            logo: "/images/markets/lbank.png",
            taker: "0.2%",
            maker: "0.2%",
            activeSince: "2015"
          },
          aster: {
            name: "Aster",
            logo: "/images/markets/aster.png",
            taker: "0.05%",
            maker: "0.02%",
            activeSince: "2023"
          },
          xt: {
            name: "XT",
            logo: "/images/markets/xtcom.png",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2017"
          },
          weex: {
            name: "WEEX",
            logo: "/images/markets/weex.png",
            taker: "0.06%",
            maker: "0.02%",
            activeSince: "2021"
          },
          phemex: {
            name: "Phemex",
            logo: "/images/markets/phemex.png",
            taker: "0.06%",
            maker: "0.01%",
            activeSince: "2019"
          },
          coinex: {
            name: "CoinEx",
            logo: "/images/markets/coinex.jpeg",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2017"
          },
          binancealpha: {
            name: "Binance Alpha",
            logo: "/images/markets/binance.jpeg",
            taker: "1.0%",
            maker: "1.0%",
            activeSince: "2024"
          }
        }
      },



      fundingIs: {
        title: "🚀️ Арбитраж фандинга: Как зарабатывать без риска и сложных стратегий",
        subtitle: "https://t.me/fundingradar_official",

        intro: "✨ Что такое арбитраж фандинга и почему это выгодно?",
        paragraph1: "Исследование финансовых рынков нередко приводит к появлению инновационных методов инвестирования, которые не только увеличивают капитал, но и обеспечивают его стабильность и надежность. Один из таких методов — арбитраж фьючерсов (фандинга). В этой статье мы рассмотрим, что такое фандинг, как он работает и как вы можете использовать его, чтобы обеспечить себе стабильный пассивный доход.",
        paragraph2: "В этом руководстве, мы рассмотрим стратегию торговли, с помощью бота Funding Bot, узнаем, что такое фандинг, в чем заключается стратегия, а также разберем некоторые примеры для входа в любую связку.",
        paragraph3: "Стратегия заработка на межбиржевом арбитраже фандинга, является одной из самых прибыльных стратегий торговли на рынке криптовалют. Она основана на получении прибыли от разницы в ставках финансирования между разными биржами, а также на получении прибыли от разницы курсов.",
        paragraph4: "Фандинг – это регулярные выплаты между трейдерами, торгующими бессрочными фьючерсами. Биржи используют этот механизм, чтобы поддерживать баланс между лонгами и шортами. Арбитраж фандинга позволяет получать прибыль, используя разницу в ставках финансирования между разными биржами или между спотом и фьючерсами.",
        paragraph5: "Главное преимущество этой стратегии – отсутствие рыночного риска. В отличие от спекуляций на курсе монеты, вы зарабатываете не на росте или падении цены, а на разнице выплат между биржами.",

        howItWorks: "🔄 Как работает арбитраж фандинга?",
        steps: [
          "Находите связку – разницу между ставками фандинга на разных биржах.",
          "Открываете две противоположные сделки: покупка (лонг) на одной бирже и продажа (шорт) на другой.",
          "Получаете пассивную прибыль за счёт начисления ставок финансирования."
        ],

        exampleTitle: "📈 Пример",
        exampleSteps: [
          "На бирже A ставка фандинга -0.7% (шорты платят лонгам).",
          "На бирже B ставка +0.06% (лонги платят шортам).",
          "Мы покупаем актив на бирже A и шортим его на бирже B.",
          "Получаем разницу ставок фандинга +0.76% каждые 8 часов!"
        ],

        whyWorks: "💪 Почему это реально работает?",
        whyPoints: [
          "Отсутствие зависимости от курса – даже если цена актива изменится, ваш доход останется стабильным, так как сделки компенсируют друг друга.",
          "Пассивный доход – после открытия позиций вы просто ждёте начисления фандинга.",
          "Минимальные риски – нет необходимости угадывать направление рынка."
        ],
        
        sectionPractice: "Перейдем к практике!",
        sectionPracticeText: "Вот так выглядит ставка финансирования на бирже:",
        sectionPracticeImg: "/images/funding/funding-rate-example.png",
        sectionPracticeCaption: "Пример отображения ставки финансирования на бирже",

        sectionFundingRate: "Cтавка финансирования",
        sectionFundingRateText: "На торговой площадке предполагается, что цена базового актива и фьючерсного контракта должны быть одинаковыми. Для того чтобы это поддерживать, введена ставка финансирования. Если цена значительно отклоняется, ставка финансирования увеличивается, открывая возможности для арбитража. Это помогает выравнять позиции длинных и коротких игроков, чтобы цена фьючерсов соответствовала текущей цене. Финансирование выплачивается каждые 8 часов, но для этого требуется наличие открытых позиций на момент расчета. Вы можете держать позицию все 8 часов, либо открыть ее за минуту до выплаты - не важно. Вы в любом случае получите выплату. На большинстве бирж расчеты производятся в 03:00, 11:00, 19:00, но на платформе KuCoin – в 07:00, 15:00, 23:00, что также можно использовать для проведения операций.",

        fundingTime: "Время расчета фандинга",
        fundingTimeText: "У каждой торговой пары есть минимальная и максимальная ставки финансирования. Если бирже нужно изменить цену фьючерсов в определенную сторону, а ограничения по ставке финансирования мешают сделать это достаточно быстро, биржи начинают уменьшать периодичность выплат с 8 часов до 4, 2 или даже 1 часа. Мы также будем пользоваться этой возможностью.",
        fundingTimeImg: "/images/funding/funding-times.png",
        fundingTimeCaption: "Время расчета фандинга",

        payoutTitle: "Как выплачивается фандинг?",
        payoutText: "Взглянем на пример: предположим, одна биржа предлагает ставку финансирования +1%, а на другой -1%. Инвестор может использовать эту разницу, открывая позицию шорт на бирже с более высокой ставкой и позицию лонг на бирже с более низкой ставкой. Разница между курсами превращается в дополнительную прибыль.",
        payoutImg: "/images/funding/funding-paids.png",
        payoutCaption: "Выплаты фандинга",

        payoutNote: "Для пояснения, если ставка финансирования положительная, +1%, то биржа выплачивает шортистам +1%, а у лонгистов будет -1%. Наоборот, если фандинг отрицательный, -1%, то биржа выплачивает лонгистам +1%, а у шортистов будет -1%.",
        
        typesFunding: "Различные типы фандинга могут иметь следующие особенности",
        fundingTypes: [
          "✅ Плавающий фандинг: Ставка меняется в зависимости от текущих рыночных условий.",
          "✅ Фиксированный фандинг: Текущая ставка остается неизменной, но может измениться на следующем периоде."
        ],
        fundingTypesNote: "Например, на бирже KuCoin используется фиксированный фандинг, в то время как на других платформах ставка может быть плавающей, т.е. изменяться в зависимости от текущей ситуации на рынке.",

        hedgeTitle: "Что такое хеджирование?",
        hedgeText: "Хеджирование - это стратегия управления рисками, которая используется на финансовых рынках. Она заключается в применении определенных инструментов или операций для снижения потенциальных убытков, связанных с изменениями цен на активы или другими факторами риска.",
        hedgeText2: "В контексте торговли криптовалютами, хеджирование может быть использовано для защиты от колебаний цен на криптовалюты. Например, трейдер может открыть одновременно две позиции: позицию на покупку (Long) и позицию на продажу (Short) одной и той же монеты, чтобы снизить потенциальные убытки в случае неблагоприятного движения рынка.",
        hedgeText3: " Если кратко: хеджирование - это открытие двух позиций в разных направлениях одновременно. Мы просто страхуем свои активы от любых возможных колебаний.",
        
        arbitrageTypes: "🔄 Виды арбитража",
        arbitrageText: "Арбитраж - это стратегия, при которой инвестор пытается заработать на разнице в ценах или ставках между различными финансовыми инструментами. Вот два основных вида арбитража, которые мы будем рассматривать:",
        arbitrageList: [
          "Фьючерс – Фьючерс: Инвестор покупает фьючерс на актив на одной бирже и одновременно продает фьючерс на тот же актив на другой бирже. Разница между ставками финансирования и ценами становится источником прибыли.",
          "Спот – Фьючерс: Инвестор покупает актив на рынке спот (немедленная доставка и оплата) и одновременно продает фьючерс на этот же актив. Мы так же зарабатываем на выплате фандинга с одной биржи и на разнице цен."
        ],
        arbitrageText2: "Цель арбитража заключается в извлечении прибыли из различий в ценах или ставках между различными финансовыми инструментами, а иногда и из этих обеих этих возможностей одновременно. Как выглядит прибыль, на основе разницы цен:",
        arbitrageImg3: "/images/funding/profit-course.png",
        arbitrageCaption3: "Прибыль на разнице цен",
        arbitrageText3: "Давайте рассмотрим пример арбитража между рынком спот (где актив покупается или продается сразу) и рынком фьючерсов (где заключаются сделки на будущее по фиксированной цене).",
        arbitrageText4: "Допустим, у нас есть актив, который мы купили на рынке спота. Параллельно мы продали фьючерс на этот же актив. Когда цены актива на рынке спота и фьючерсов выравниваются, мы можем закрыть наши позиции, получив прибыль.",
        arbitrageText5: "Мы также можем получить дополнительную прибыль от выплаты фандинга, если ставка финансирования положительная. Поэтому, когда цены выравниваются, и мы получаем выплату финансирования, это может стать хорошим моментом для закрытия наших позиций и получения максимальной прибыли. Мы можем удерживать наши позиции в течение нескольких дней или недель, если выплата фандинга устраивает нас.",
        

         priceDifferenceTitle: "📊 Рассмотрим подробнее насчет разницы цен",
        priceDifferenceText: "Помимо арбитража ставки финансирования, мы обязаны обращать внимание на разницу цен между активами. Это и будет основной источник нашей прибыли!",

        priceDifferenceExampleText2: "Пример (спред входа 1%)",
        priceDifferenceList2: [
          "На бирже А, bitcoin стоит 50,000$ (спот).",
          "На бирже В, bitcoin стоит 50,500$ (фьючерсы).",
          "Если мы купим на бирже А, один bitcoin по цене 50,000$.",
          "На бирже В, мы откроем позицию в шорт также, на один bitcoin.",
          "То когда bitcoin на бирже А будет стоить столько же, сколько на бирже В, мы заработаем на разнице цен между активами!",
          "Представим, что цена оказалась 50,250$ на двух биржах, после того, как мы открыли наши позиции, выходит, что на бирже А мы заработали 250$, поскольку на споте наша монета стала стоить дороже, и на бирже В мы заработали 250$, поскольку мы открыли позицию в шорт, и курс пошел вниз. В итоге мы заработаем 500$, если бы мы зашли в монету примерно по 50,000$ на каждой бирже, если войдем в неё при спреде входа 1% и выйдем при спреде выхода 0%.",
        ],


        priceDifferenceNote: "Использовать можно любой депозит (хоть 10$, 50$, 200$, 1000$, 10000$), если в монете есть ликвидность.",
        priceDifferenceNote2: "Это и есть заработок на разнице курсов, или же цен между активами!",

        botConceptsText: "В нашем боте есть два важных понятия. Они нам пригодятся и являются одними из основных для получения прибыли. Они пригодятся нам чуть позже.",
        botConceptsList: [
          " Спред входа: Показывает разницу между ценами двух бирж, если бы мы только входили в связку (то есть покупали на одной бирже, и открывали шорт на другой), если он положительный, значит цены расходятся в выгодную для нас сторону, если отрицательный, то спред входа уже не такой выгодный. Нам нужно поймать момент, когда он максимально положительный!",
          "Спред выхода: Показывает разницу между ценами двух бирж, если бы мы выходили из связки (то есть продавали монеты на споте, и закрывали шорт на другой бирже), если он стал более отрицательным, чем спред входа, при котором мы входили, то мы заработаем на этом!"
        ],

        priceArbitrageStrategyTitle: "Стратегия арбитража разницы цен",
        priceArbitrageStrategyText: "Основная наша стратегия заключается в том, что мы анализируем листинги на биржах, находим те, где будут спот и фьючерсы (на одной и той же или на разных биржах). Для тех кто не знает, что такое листинг криптовалюты - это процедура включения токена в список активов, доступных для торговли на бирже.",
        priceArbitrageStrategyText2: "После того, как мы нашли нужный листинг, мы должны подготовиться и заранее перевести депозит на нужную(-ые) нам биржу(-ы) и ждать время начала торговли, чтобы в основном, в первый час торговли, успеть войти в связку с выгодным спредом входа и выйти с выгодным спредом выхода. Обычно в первые 5 минут на листингах часто бывает большой разрыв в ценах, даже между спотом и фьючерсом на одной и той же бирже. И как только мы видим положительный спред входа, дожидаемся, если он растет, либо входим в связку если он +0-50% и ждем схождения курсов и выходим, когда спред выхода -0-3% примерно, но это нужно вам самим решать, при каком спреде входа входить и выходить, как вы считаете выгодным.",
        priceArbitrageStrategyText3: "Иногда бывает, что спред входа не слишком большой, допустим 3-5% на листинге, но можно входить даже в небольшой % спреда входа и выхода, и делать круги. Особенно, если мы торгуем на одной бирже, между спот / фьючерс, цены со временем сойдутся по любому, и если мы войдем в положительный спред входа, то он по любому станет примерно равным нулю. Поскольку на листингах очень сильно прыгает цена, мы можем входить допустим в 5% спреда входа, ждать и выходить в -5% - 2% спреда выхода, и довольно часто, спред входа и выхода на листингах прыгают туда-сюда, что позволяет нам например за 1 листинг, более 10 раз (а иногда и более 50 раз), войти допустим на 5% и выйти на 0%. Тем самым за 10 кругов можно заработать около 25% от депозита.",

        fundingArbitrageStrategyTitle: "Стратегия арбитража ставок финансирования",
        fundingArbitrageStrategyText: "Стратегия арбитража ставок финансирования заключается в том, что мы будем использовать хеджирование на разных биржах для страхования актива, а прибыль будем получать с процентных ставок и разнице курсов между биржами. Рассмотрим для примера сделку, которую нам предложил Funding Bot @funding_cryptoprojects_bot",
        fundingArbitrageStrategyText2: "По началу не обращайте внимание на все данные в этой связке, мы рассмотрим их дальше. Сейчас важно понять, как работает наша стратегия. Пример:",
        fundingArbitrageStrategyImg3: "/images/funding/spread.jpg",
        fundingArbitrageStrategyCaption3: "Связка",

        exampleBundleText: "В данном примере мы видим связку, которую выдал нам бот, между биржами Bitget и Mexc. Что же примечательного в этой связке?",
        exampleBundleText2: "Мы видим, что бот нам предлагает купить в лонг на Bitget и зайти в шорт на Mexc, тем самым мы заработаем 0.49% на фандинге, поскольку на бирже Bitget он является -2%, а на бирже Mexc -1.51%, но это не самое главное!",
        exampleBundleText3: "На данной связке нужно обращать внимание на спред входа, и он является 5.13%, а это довольно много! Ведь всегда вход и выход стремятся к нулю! А значит мы сможем заработать 5% на этой связке.",
        exampleBundleText4: "Но почему эта монета отличается от других и в неё стоит войти, ведь бывают и другие монеты где высокий спред входа?",
        exampleBundleText5: "Необходимо проанализировать, что это вообще за монета, когда она вышла на биржи(когда был листинг), её ликвидность, когда будет открыт вывод и ввод с одной биржи на другую этой монеты. Проанализировав, можно заметить, что эта монета появилась несколько часов назад на популярных биржах, и у неё высокая ликвидность, а это значит, что вывод и ввод между биржами откроется скорее всего на следующий день примерно в 14:00 по МСК. Если мы войдем в данную связку, и дождемся до открытия вывода на биржах, чтобы арбитражники смогли выравнять цены, спред входа и выхода будут около нуля! Так всегда происходит когда открывают ввод вывод на популярных монетах. И тогда мы закроем нашу связку со спредом выхода 0% или еще меньше, и получим неплохую прибыль!",
        exampleBundleText6: "Так же мы будем получать выплаты фандинга на этой связке, и это еще небольшая пассивная прибыль для нас.",
        exampleBundleText7: "А теперь нужно изучить, как же правильно войти в связку и какие подводные камни бывают на разных биржах.",

        

        howToEnterBundlesTitle: "Как входить в связки?",
        howToEnterBundlesText: "Для начала, необходимо нажать на кнопку \"График\" под сообщением бота о найденной связке (либо нажать кнопку Инфо и там вручную вбить монету, биржу, и выбрать фьючерс/фьючерс или спот/фьючерс).",
        howToEnterBundlesText2: "У нас есть веб-версия для отслеживания спреда входа и выхода в реальном времени! Благодаря этому мы видим как прыгает вход и выход вверх и вниз, и благодаря этому мы сможем точно входить с нужным спредом входа и выходить с текущим спредом выхода! Главное одновременно открыть и закрыть позиции на двух биржах, это довольно легко, нам не нужно много ловкости для этого. Ниже можно увидеть пример спреда входа и выхода данной монеты на следующий день, когда вывод на биржах стал открыт, благодаря чему вход и выход стали 0%!",
        
        fundingArbitrageStrategyImg3: "/images/funding/web-version.jpg",
        fundingArbitrageStrategyCaption3: "Веб-версия",

        webVersionText: "Если мы видим на графике, что спред входа такой же высокий 5%, мы можем войти в данную связку и подождать, когда спред выхода станет 0% или еще меньше и выйти со связки! Иногда на листингах можно сделать кучу таких кругов, и без веб-версии вы не сможете мгновенно реагировать на повышение и понижение входа и выхода, поскольку они часто изменяются очень быстро.",

        preparationText: "Итак мы нашли монету, она нам подходит, открыли график, отслеживаем вход. Нам теперь нужно подготовиться ко входу в связку!",
        preparationText2: "Для этого, смотрим балансы наших бирж, выбираем покупку по рыночной цене (по маркету) и на второй бирже открытие позиций по рыночной цене, и смотрим сколько всего монет мы можем купить. Допустим мы можем купить примерно 10000 монет, тогда нам нужно заранее подготовиться.",
        preparationText3: "Открываем 2 вкладки в браузере с биржами и выбранными монетами. Для начала, ставим на двух биржах, если мы входим и лонг и шорт, кредитное плечо х1, это обязательно для новичков. Затем, заходим на биржу где мы хотим купить (или войти в лонг), и по рыночной цене выбираем примерно 70-80% от нашего депозита (чтобы в случае повышения или понижения цены, нам хватило депозита на то, чтобы войти в связку, ведь курсы монет меняются на двух биржах вверх и вниз). Допустим мы выбрали на первой бирже 8000 монет и на второй бирже 8000 монет по рынку. Затем нажимаем на одной бирже открыть лонг, на второй бирже открыть шорт. У нас откроются окна дополнительного подтверждения (почти на всех биржах такое есть). Затем мы смотрим на наш график и ждем подходящий момент для входа! Как только нас устраивает спред входа, нажимаем открыть лонг, переключаемся на вкладку со второй биржей и нажимаем открыть шорт на второй бирже и так мы уже вошли в связку! Чтобы выйти делаем так же, переключаемся на закрытие позиций, выбираем 100% наших монет что уже в позициях, и нажимаем закрыть лонг на одной бирже и закрыть шорт на второй бирже. Ждем как будет удачный момент спреда выхода и закрываем позиции! Есть один лайфхак чтобы быстро переключаться между вкладками бирж!",

        quickSwitchText: "Чтобы быстро открыть одновременно или закрыть позиции, открываем допустим первую биржу Bitget вторую Mexc, у нас по центру экрана на двух биржах уже открыто подтверждение входа и связку. Мы должны расположить в браузере Bitget слева на первом месте, а второй вкладкой сделать Mexc. В браузерах часто есть сочетание клавиш ctrl+1 и ctrl+2, благодаря чему, можно одной рукой переключать вкладки, а другой нажимать мышкой на кнопку! Мы просто нажимаем левой кнопкой мыши открыть лонг, затем сразу ctrl+2 и переключаемся на вторую вкладку, и снова нажимаем открыть шорт, и тем самым мы сэкономили время на том, чтобы мышкой сверху выбрать нужную вкладку браузера! Перед входом в связки проверьте, работает ли у вас данное сочетание клавиш.",



        examplesTitle: "Посмотрим несколько примеров",
        examplesText: "Допустим по монете HBAR между kucoin и bybit, как нужно входить в связку, на данной бирже мы выбрали кредитное плечо х1, рынок, выбрали часть баланса (не весь баланс), и нажмем затем продать/шорт. Обязательно нужно выбирать сумму в монетах, а не долларах!",
        examplesArbitrageStrategyImg2: "/images/funding/hbar.png",
        examplesArbitrageStrategyCaption2: "Покупка HBAR в шорт на Kucoin",

        hbarShortText: "Не рекомендую новичкам использовать кредитные плечи больше х1, поскольку как убыток так и прибыль может быть в разы больше, я обычно использую плечи х1-х3, в зависимости от монеты, х3 крайне редко, поскольку если курс монеты сильно прыгает, может наступить ликвидация.",
        hbarLongText: "На другой бирже так же заходим, только в лонг, выбираем рынок, ставим заполнить по количеству (чтобы вводить кол-во монет, а не кол-во долларов), плечо х1 и нажимаем купить в лонг.",
        
        examplesArbitrageStrategyImg3: "/images/funding/long.png",
        examplesArbitrageStrategyCaption3: "Покупка HBAR в лонг на Bybit",
        hbarLongText2: "И вот мы вошли на одинаковое кол-во монет и ждем спред выхода около 0%, а так же выплаты фандинга, либо не дожидаясь фандинга, если вход и выход часто прыгают до высоких плюсовых значений и опускаются примерно до нуля, то можно делать круги и зарабатывать на разнице курсов!",
        hbarLongText3: "Если мы оставляем связку на ночь или на долгое время (без присмотра), тогда необходимо выставить Take-Profit и Stop-Loss это поможет нам более корректно закрыть сделки практически без убытка, если наступит ликвидация, это важно.",
        

        risksTitle: "Риски",
        risksText: "На самом деле здесь риски не большие:",
        risksList: [
          "Расхождение курсов: Вы вошли в малоизвестную монету (красную) и курс на биржах резко разошелся в разные стороны и наши позиции ликвидировало (для этого ставим Stop-Loss и Take-Profit) такой риск есть, но он очень маленький, и если мы поставили стоп-лосс и тейк-профит то мы много на этом не потеряем. У нас нет риска потерять весь баланс.",
          "Если мы зашли в спот/фьючерс, у нас единственный риск, если курс очень сильно вырастет, ведь мы вошли в шорт, то есть если курс упадет, то никаких рисков ликвидации нет! Поэтому связки спот / фьючерс более безопасные, а так же у них сильнее всего отличается курс между биржами, благодаря чему часто бывает высокий спред входа.",
          "Незначительные потери при изменении ставки финансирования: Возможно, что цены актива могут измениться в невыгодную для нас сторону, и ставка финансирования может поменяться. Однако такие ситуации крайне редки, и потери обычно остаются незначительными.",
          "Необходимость анализа и обдумывания: Нет необходимости спешить с совершением сделки. Можно все тщательно проанализировать и обдумать. Поскольку мы одновременно заходим в лонг на одной бирже и в шорт на другой, изменение курса нас не затрагивает. Но иногда, если хотим заработать на разнице спредов входа и выхода, стоит поторопиться, поскольку высокий спред обычно долго не держится."
        ],

        automationTitle: "🌟 Как автоматизировать арбитраж и не тратить время впустую?",
        automationText: "Постоянно мониторить ставки фандинга вручную – неэффективно. Курс меняется, связки появляются и исчезают, а вручную подбирать оптимальный вариант сложно.",
        automationText2: "🌟 Наш бот FundingRadar решает эти проблемы за вас!",

        automationList: [
          "Анализирует тысячи связок между биржами в реальном времени.",
          "Выдаёт лучшие варианты с расчётом прибыли.",
          "Возможность фильтрации связок по ставке финансирования и спреду входа",
          "Можно активировать мониторинг и вы получите уведомление о новой прибыльной связке",
          "Бесплатный тестовый период на 6 часов!",
          "Реферальная система с каждой оплаты вашего реферала, вы получаете 20%!"
        ],

        webVersionTitle: "🌐 Веб-версия: Интерактивные графики и удобный анализ",
        webVersionText: "Для удобства мы разработали веб-версию бота. Она включает:",
        webVersionList: [
          "✅ Интерактивные графики спреда входа и выхода в реальном времени.",
          "✅ Исторический график спреда входа и выхода по каждой монете.",
          "✅ Подсчёт доходности с учётом объёма стакана.",
          "✅ Гибкий выбор глубины анализа (x3 или x5 значений).",
          "✅ Раздел с информацией о подписке, а также приглашенными рефералами.",
          "✅ Раздел с полезными статьями и ответами на популярные вопросы."
        ],
        webVersionNote: "Теперь вам не нужно быть профессионалом в трейдинге – всё просчитано за вас!",

        profitSection: "прибыль на разнице цен",
        conclusion: "Заключение",
        conclusionText: "Чтобы получить еще больше информации, следите за нашим телеграм каналом, там мы иногда выкладываем бесплатные связки, а так же там вы сможете найти результаты арбитража наших подписчиков. У нас так же есть приватный чат подписчиков, где мы обсуждаем все связки и находим новые! Для его вступления необходимо оплатить подписку и написать в техподдержку. Всем удачных связок и кучу долларов 💲💲💲",
        telegram: "Наш телеграм канал: FundingRadar",
        bot: "Funding Bot",
        bot_url: "https://t.me/funding_cryptoprojects_bot",
        bot_image: "/images/funding/fbot.jpg"
      },
      aboutBot: {
        title: "Инструкция по использованию бота для арбитража фандинга",
        subtitle: "https://t.me/fundingradar_official",
        intro: "✨ Введение",
        paragraph1: "Данный бот предназначен для облегчения процесса арбитража фандинга между различными криптовалютными биржами. С его помощью вы можете отслеживать выгодные связки, получать уведомления и анализировать данные для принятия обоснованных торговых решений.",
        section1: {
          title: "Основные разделы бота",
          list: [
            "🔄  Фьючерсы: Отображает все доступные связки между фьючерсными контрактами на разных биржах.",
            "🔀  Спот/Фьючерсы: Показывает связки между спотовыми и фьючерсными рынками.",
            "🔴  Черный список: Позволяет добавлять монеты в черный список.",
            "🏦 Биржи: Список всех бирж, интегрированных в бота. Вы можете отключить ненужные биржи по своему усмотрению.",
            "🔔  Мониторинг: Позволяет установить пороговые значения для фандинга или спреда входа. При превышении этих значений бот автоматически отправит вам уведомление."
          ],
          img: "/images/aboutbot/sections-tg.png",
          caption: "Основные разделы"
        },
        section2: {
          title: "Терминология и показатели 📊",
          text: "Под названием каждой биржи, вы можете увидеть данные о текущем спреде на них.",
          list: [
            "Текущая: Показывает текущую ставку финансирования на данной бирже.",
            "Прогнозная: Доступна только на KuCoin; показывает ожидаемую следующую ставку финансирования.",
            "Стремится: Показывает ставку финансирования, к которой стремится текущая, так можно определить, она растет сейчас или уменьшается.",
            "Часы: Означают частоту выплаты фандинга, биржи иногда уменьшают до 4 часов или до 2 или 1, если необходимо, благодаря чему, можно получить на одной из бирж больше выплат.",
            "Накопленный: Суммарная ставка финансирования за выбранный период (1, 3, 7 или 30 дней)."
          ],
          img: "/images/aboutbot/terminology.png",
          caption: "Данные связки"
        },
        section3: {
          title: "Спред",
          text: "Ниже данных о каждой бирже есть \"💰 Спред:\".",
          list: [
            "Текущий: Показывает прибыль от фандинга между двумя биржами, необходимо учитывать, что эта прибыль идет с половины вашей общей суммы",
            "Комиссия: Общая комиссия тейкера с учетом того, что на каждой бирже будет одинаковое количество монет",
            "Спред входа: Если вы зашли в отрицательный - нужно выйти в еще более отрицательный. Если вы зашли в положительный - нужно выйти в менее положительный, ноль или отрицательный. При входе в сделку, нужно учитывать 'Спред входа' и чем он больше, тем лучше, и перед выходом из сделки, нужно смотреть на 'Спред выхода'.",
            "Спред выхода: Он должен быть меньше вашего спреда входа, который был, чтобы заработать на разнице курсов. То есть необходимо чтобы спред выхода, был более отрицательным чем спред вашего входа.",
            "Накопленный: Показывает накопленную ставку финансирования между двумя биржами фьючерс/фьючерс. Если это спот/фьючерс, тогда для одной биржи."
          ],
          img: "/images/aboutbot/spread.png",
          caption: "Спред"
        },
        section4: {
          title: "График",
          paragraph: "При нажатии на график или кнопку \"Инфо\" слева от ввода сообщения, вы переходите на нашу веб-версию, где отображается график спреда входа и выхода выбранной связки в реальном времени, а так же присутствует стакан, с объемом в долларах $.",
          img: "/images/aboutbot/graphic.png",
          caption: "Кнопка \"График\""
        },
        section5: {
          title: "Веб-версия",
          text2: "На вкладке Торговля:",
          list: [
            "В самом верху, вы можете выбрать монету, тип \"Фьючерс/Фьючерс\" или \"Спот/Фьючерс\", а так же биржи, между которыми вы хотите мониторить связку.",
            "Чуть ниже, идут настройки, вы можете указать объем (в долларах $) и нажать на кнопку чуть правее, чтобы загорелся синий кружочек, тогда спред входа и выхода на графике будет показывать с учетом подсчитанного объема стакана, например, указав 1000$, у вас будет отображаться спред входа и выхода, если бы вы зашли в связку на текущий объем на каждой бирже по 1000$, и так будет легко определить, хватает ли ликвидность в текущей связке на данный объем. Данный объем указывается для каждой биржи отдельно! То есть, если вы выставили 500$, это означает, допустим, что на одной бирже вы купите на 500$ и на второй бирже, откроете шорт тоже на 500$. При повторном нажатии на кнопку, она станет серой, значит подсчет с учетом объема стакана отключен.",
            "Чуть правее выставления объема и кнопки его включения выключения, идут еще 2 кнопки. Кнопка \"3\" (\"5\") означает глубину стакана, если вам недостаточно глубины \"3\" можно нажать на кнопку и глубина стакана будет \"5\".",
            "Первый график, после настроек, отображает текущий спред входа и выхода, вместе со стаканом, благодаря чему, вы сможете в реальном времени отслеживать вход и выход для каждой интересующей вас связки, в том числе вы сможете узнать, хватает ли ликвидности в стаканах и на какой объем можно входить на данной монете без сильного проскальзывания.",
            "Слева сверху на графике, есть кнопка \"⚙️ Настройки\", чтобы открыть дополнительные настройки для ввода цен, по которым вы вошли в связку для автоматического подсчета спреда входа и выхода, а также вывода их на график в виде линий для удобства.",
            "После нажатия на \"⚙️ Настройки\" так же будет доступен \"Колокольчик\" и при указании пороговых значений, вы будете слышать звонок и не пропустите вход или выход со связки.",
            "Кнопка \"+\" на графике слева сверху позволяет открывать много копий бота на ПК или смартфонах, полезно, если вы хотите отслеживать сразу несколько графиков."
          ],
          list2: [
            "Второй график, который идет ниже, показывает исторический спред входа и выхода на каждую 1 минуту за последние 48 часов, благодаря этому графику, очень удобно анализировать, какой спред входа и выхода был у данной монеты, чтобы можно было определить удачный момент входа, так проще понять, когда лучше войти, а когда пора выходить из связки. (слева сверху есть кнопка \"Лупа\", чтобы можно было активировать возможность зума и передвижения по графику).",
            "Справа от графиков, по оси Y указываются спред входа и выхода в % значении. Снизу графиков, по оси X указывается время, в нижнем графике указываются часы.",
            "Снизу в веб-версии есть вкладки, \"Торговля\", \"Спреды\", \"Подписка\", \"Информация\". Первая и вторая вкладка это основные, где мы занимаемся торговлей."
          ],
          img: "/images/aboutbot/web-version.png",
          caption: "Веб-версия",
          img3: "/images/aboutbot/history-graph.png",
          caption3: "График истории спреда"
        },
        section6: {
          title: "На вкладке Подписка",
          list: [
            "Можно просмотреть всю необходимую информацию о состоянии подписки, сколько осталось дней или часов, а так же там находится ваша реферальная ссылка (вы будете получать 20% от каждой оплаты подписки вашего реферала), и чуть ниже пишутся все ваши рефералы, в том числе, протестировали ли они бота, или же уже купили подписку."
          ],
          img: "/images/aboutbot/subscribe.png",
          caption: "Вкладка подписка",
        },
        section7: {
          title: "На вкладке с Информацией",
          paragraph: "Вы сможете найти полезные ссылки на наши ресурсы, в том числе и ответы на популярные вопросы.",
          img: "/images/aboutbot/info.png",
          caption: "Информация",
        },
        section8: {
          title: "Рекомендации по использованию 💡",
          paragraph: "Для успешной сделки, необходимо все просчитать, и одновременно купить монеты по рыночному ордеру на одинаковую сумму на двух биржах, можно открыть 2 вкладки браузера для удобства и переключаться между ними с помощью ctrl+1 и ctrl+2 если вкладки находятся на первой и второй слева позиции, так будет проще переключить и сразу же подтвердить мышкой покупку или продажу монет сразу на двух биржах, заранее наведя её по центру экрана для подтверждения ордеров."
        },
        section9: {
          title: "На вкладке Спреды",
          list: [
            "Можно просмотривать удобно текущие спреды с автообновлением каждые 4 секунды.",
            "Есть возможность выбрать сортировку по \"Вход\" или по \"Фандинг\", а так же \"Вход > 0\", включить или выключить автообновление \"Авто\", выбрать сколько спредов показывать на одной странице \"5\", \"7\", \"10\", \"20\", и самое полезное Колокольчик.",
          ],
          list2: [
            "При нажатии на Колокольчик, вы сможете установить пороги для входа и выхода, и когда один из спредов по фьючерс/фьючерс или спот/фьючерс перейдет порог, вы услышите звонок и вовремя среагируете. Это учень удобно и можно даже отойти от ПК или смартфона, и услышав звонок, не пропустить спред.",
            "Есть возможность выбрать сортировку по \"Вход\" или по \"Фандинг\", а так же \"Вход > 0\", включить или выключить автообновление \"Авто\".",
          ],
          img: "/images/aboutbot/spreads-web.png",
          caption: "Вкладка спреды",
          img3: "/images/aboutbot/colocol-web.png",
          caption3: "Колокольчик",
        },
        textfuter: "На большие суммы (в зависимости от стакана, примерно от 2000$) лучше заходить по частям, чтобы избежать проскальзывания (чтобы не потерять на курсе). Можно использовать плечо (например, 4х) при торговле на фьючерс/фьючерс, для увеличения прибыли в 4 раза. Использовать плечо, крайне не рекомендуется новичкам, на первых связках."
      }

    }
  },
  en: {
    translation: {
      menu: {
        title: "Menu",
        home: "Home",
        tarifs: "Pricing",
        info: "Information",
        funding: "What is funding?",
        instruction: "About the bot",
        markets: "Supported exchanges",
        faq: "FAQ",
        fundingRates: "Funding spreads"
      },
      navbar: {
        trade: "Trade",
        spreads: "Spreads",
        subscription: "Subscription",
        info: "Info"
      },
      bell: {
        futuresThreshold: "Futures threshold (%)",
        spotThreshold: "Spot/Futures threshold (%)",
        dexThreshold: "DEX threshold (%)",
        blacklist: "Blacklist",
        thresholdPlaceholder: "e.g. 5",
        thresholdPlaceholder10: "e.g. 10",
        thresholdPlaceholder5: "e.g. 5"
      },
      spreads: {
        entry: "Entry",
        funding: "Funding",
        auto: "Auto",
        entryGt0: "Entry > 0",
        back: "⬅ Back",
        trade: "Trade",
        noData: "No spreads to display.",
        noSub: "You don't have an active subscription.",
        noSubDesc: "You need to subscribe to continue.",
        subscription: "Subscription",
        dataUnavailable: "Data unavailable.",
        noDataForPair: "No data for this pair.",
        noSubActive: "No active subscription.",
        searching: "Searching...",
        coinNotFound: "Coin not found",
        backToList: "Back to list",
        exit: "Exit",
        volume24: "Volume 24h",
        price: "Price",
        current: "Current",
        spreadEntry: "Entry spread",
        contract: "Contract",
        dexLink: "Link",
        searchPlaceholder: "Search coin...",
        futuresFutures: "Futures/Futures",
        spotFutures: "Spot/Futures",
        coinInput: "Enter coin (BTC, ETH...)",
        volume: "Volume",
        loading: "Loading...",
        connect: "Connecting…"
      },
      trade: {
        futuresFutures: "Futures/Futures",
        spotFutures: "Spot/Futures",
        coinInput: "Enter coin (BTC, ETH...)",
        volume: "Volume",
        loading: "Loading...",
        noSubTitle: "You don't have an active subscription.",
        noSubDesc: "You need to subscribe to continue.",
        subscription: "Subscription",
        connect: "Connecting…",
        dexMarket: "DEX",
        coinInput2: "Enter coin 2 (BTC, ETH...)",
        placeholder: "Enter coin (BTC, ETH...)",
        market1: "Exchange 1",
        market2: "Exchange 2"
      },
      subscription: {
        title: "My subscription",
        active: "Active",
        inactive: "Inactive",
        remaining: "Remaining:",
        payBtn: "Pay subscription",
        myReferral: "My referral link",
        referralDesc: "Partner reward is charged from each subscription payment by your referrals, or renewal, in the amount of 20% of the subscription cost.",
        copy: "Copy",
        copied: "Copied!",
        invitedUsers: "Invited users",
        test: "Test",
        subscribe: "Subscribe",
        noInvited: "No invited users",
        withdrawInfo: "To withdraw funds, send a message to support @xWHOxAMxIx with your payment details.",
        withdrawNote: "Withdrawal requests are processed within 48 hours.",
        paymentTitle: "Subscription payment",
        network: "Network",
        price: "Price",
        address: "Transfer address:",
        memo: "Memo (required):",
        paymentNote: "Payment will be confirmed automatically. If you have questions or need other payment methods — contact support:"
      },
      menu: {
        title: "Menu",
        home: "Home",
        tarifs: "Pricing",
        info: "Information",
        funding: "What is funding?",
        instruction: "All about the bot",
        markets: "Supported Exchanges",
        faq: "FAQ",
        fundingRates: "Funding spreads"
      },
      seo: {
        home_title: "FundingRadar | Funding Arbitrage",
        home_desc: "FundingRadar — a unique Telegram bot for trading, funding arbitrage, and spread monitoring. A convenient arbitrage tool right inside Telegram Mini App.",
        faq_title: "FundingRadar | FAQ",
        faq_desc: "Answers to common questions about subscription, payments and how the bot works.",
        pricing_title: "FundingRadar | Pricing Plans",
        pricing_desc: "FundingRadar — a unique Telegram bot for trading, funding arbitrage, and spread monitoring. A convenient arbitrage tool right inside Telegram Mini App.",
        markets_title: "FundingRadar | Supported Exchanges",
      },
      banner: {
        title: "FUNDING BOT",
        subtitle: "like no other!",
        buy: "Buy subscription",
        consult: "Consultation"
      },
      landing: {
        title: "A professional tool for funding arbitrage between CEX and DEX exchanges",
        lead: "Monitor funding rates and catch profitable pairs between exchanges — earn on rate and price differences effortlessly. Supports Hyperliquid and popular CEX platforms.",
        point1: "Instant signals — data every 100 ms",
        point2: "Supports Hyperliquid, Binance, Bybit, Mexc, Gateio, LBank and more",
        point3: "All inside a Telegram bot — no APIs or tricky settings",
        trial: "6 hours free",
        ask: "Ask a question",
        supportTitle: "Support & Education",
        supportText: "Detailed tooltips, tutorials, and a private chat for users — we help you understand and apply funding arbitrage strategies.",
        carouselLabel: "App screenshots",
        dotsLabel: "Slider dots",
        dotAria: "Go to slide {{i}}",
        screens: {
          1: "Real-time chart",
          2: "Historical spread chart",
          3: "Spot/Futures pairs",
          4: "Single-coin spreads",
          5: "Pair"
        },
        whyTitle: "Why traders choose FundingRadar",
        ctaTitle: "Try FundingRadar for free",
        ctaText: "Trial period — 6 hours. Get full access to all features and start funding arbitrage today.",
        tryNow: "Try now"
      },
      benefits: {
        speed: "Instant signals",
        speedText: "Updates every 100 ms — you see opportunities first.",
        exchanges: "CEX + DEX support",
        safety: "Security",
        safetyText: "No connections to your accounts — the bot holds no funds and operates manually.",
        support: "Training & Community",
        supportText: "Guides, case studies, and a private chat for users — helping you start faster and scale effectively.",
        seoText: "FundingRadar is a funding arbitrage scanner. Our service tracks funding rates and spreads between exchanges (CEX and DEX — Hyperliquid), showing where it’s profitable to buy or sell and how much you can earn from the difference. Funding arbitrage, spread history, and top alerts — all in one tool for traders and arbitrageurs.",
        exchangesText: "Hyperliquid, Binance, Bybit, Kucoin, Mexc, LBank, Gateio, Bitget, and more — all platforms in one scanner."
      },
      landingProduct: {
        title: "Futures Arbitrage and Profit from Price Differences",
        description: "This type of arbitrage replaced inter-exchange (buy on one exchange, sell on another) and P2P arbitrage — everything works without cards. You only need USDT. We work with top-tier exchanges and track differences through various filters. Supports spot+futures and futures+futures. The service shows where to buy, where to short, and displays volume, spread history, and funding rates for extra profit. Today, this is the most profitable arbitrage type. Our clients regularly catch 5–25% spreads and earn up to 30% per month publicly. See real cases for examples.",
        button: "Learn more",
        subImage1Alt: "Example 1",
        subImage2Alt: "Example 2",
        case: "Client case example: during sharp price moves or listings, a difference forms between futures+futures or spot+futures. The client opened a long at $0.1332 and a short at $0.1402 on another exchange. After 9 minutes, prices converged and the client earned $70 — higher than normal USDT staking, and almost risk-free.",
        mainImageAlt: "Futures Arbitrage"
      },
      pricing: {
        title: "Choose your plan",
        tryBtn: "Try",
        month1: {
          title: "1 Month",
          oldPrice: "$70",
          newPrice: "$40",
          features: [
            "Access to all FundingRadar features",
            "Fast search for the best spreads",
            "Spot and futures support",
            "Instant Telegram alerts",
            "Real spread history charts",
            "Access to private chat",
            "Educational materials with strategy examples",
            "Perfect to test and evaluate results",
            "Cheapest plan among competitors"
          ]
        },
        month3: {
          badge: "🔥 Best value plan",
          title: "3 Months",
          oldPrice: "$180",
          newPrice: "$75",
          discount: "Save 40%",
          features: [
            "Full access without limits",
            "Fast search for the best spreads",
            "Spot and futures support",
            "Instant Telegram alerts",
            "Real spread history charts",
            "Access to private chat",
            "Educational materials with strategy examples",
            "40% savings and stable access",
            "Ideal for active traders"
          ]
        }
      },
      testimonials: {
        title: "Why FundingRadar is the best crypto arbitrage scanner",
        chatLabel: "Private client chat",
        prev: "Previous review",
        next: "Next review",
        dotsLabel: "Review navigation dots",
        dotAria: "Go to review {{i}}",
        items: [
          {
            imgAlt: "Client photo 1",
            title: "+$33 in a day — subscription paid off",
            text: "Entered the trade again, took funding twice at 2%, closed in profit. +$33 today — subscription paid off!",
            author: "Ulan, client"
          },
          {
            imgAlt: "Client photo 2",
            title: "Earned +$530 in one day!",
            text: "+$530 total from all trades. Didn’t beat my record, but that’s fine!",
            author: "ORERT, trader"
          },
          {
            imgAlt: "Client photo 3",
            title: "Review of our free training",
            text: "Message him directly — seriously, worth it! Explains everything clearly and answers every question.",
            author: "E//2, arbitrage trader"
          }
        ]
      },
      trial: {
        title: "Want to see how it works?",
        lead: "Contact support and we’ll give you 6-hour trial access.",
        note: "You can also check our Telegram channel to see client results.",
        telegramText: "Open channel",
        button: "6 hours free",
        contactSupport: "Contact support",
        emailSubject: "Trial access request",
        telegramUrl: "https://t.me/fundingradar_official",
        fundingBotUrl: "https://t.me/funding_cryptoprojects_bot",
        supportUrl: "https://t.me/xWHOxAMxIx",
        imageAlt: "Robot illustration"
      },
      affiliate: {
        title: "Are you a blogger and want to earn with our affiliate program?",
        subtitle: "We’re ready to pay up to 50% per sale.",
        description: "The most generous affiliate program. If you own a YouTube, Telegram channel, website, or blog — we offer you a partnership system. Contact us on Telegram @xWHOxAMxIx",
        button: "Contact on Telegram",
        imageAlt: "FundingRadar affiliate program"
      },
      infoPage: {
        title: "Информация",
        description: "На данной странице вы сможете найти всю необходимую информацию о нашем боте арбитража фандинга.",
        ourSite: "Наш сайт",
        ourChannel: "Наш канал",
        usefulLinks: "Полезные ссылки",
        support: "Техподдержка",
        whatIsFunding: "Что такое фандинг?",
        botGuide: "Инструкция по боту",
        popularQuestions: "Популярные вопросы"
      },
                  infoPage: {
        title: "Information",
        description: "Here you can find all the necessary information about our funding arbitrage bot.",
        ourSite: "Our website",
        ourChannel: "Our channel",
        usefulLinks: "Useful links",
        support: "Support",
        whatIsFunding: "What is funding?",
        botGuide: "Bot guide",
        popularQuestions: "Popular questions"
      },
      topFunding: {
        title: "Top 16 Coins by Funding Rate",
        subtitle: "Live funding rates across exchanges",
        fundingDiff: "Diff",
        info: "Updates every 10 seconds. Funding values are current rates for the period.",
        lastUpdate: "Last update",
        futuresTitle: "Futures",
        spotTitle: "Spot/Futures"
      },

      social: {
        title: "Got questions? We’ll be happy to answer",
        sub: "Follow our social networks and get 6 hours for free.",
        buttons: {
          telegram: "Telegram channel",
          support: "Support",
          youtube: "YouTube",
          privateChat: "Private chat"
        },
        disclaimer: "IMPORTANT! We are not only software developers but also traders. Our bot is built for maximum reliability and stability. We do not provide investment advice or promise profits, nor do we handle your funds. Our software is fully manual — your funds remain under your control. We share examples of past results from our clients, but we do not advise copying their actions exactly. Your profit depends entirely on your actions and market conditions. The FundingRadar team is not responsible for your results.",
        telegramUrl: "https://t.me/fundingradar_official",
        supportUrl: "https://t.me/xWHOxAMxIx",
        youtubeUrl: "https://www.youtube.com/@fundingradar",
        privateChatUrl: "https://t.me/+iIBEKxXveOMwYjRi",
        imageAlt: "Illustration: follow us on social"
      },
      markets: {
        title: "List of Supported Crypto Exchanges",
        subtitle: "This section presents a list of CEX exchanges supported by our scanner.",
        columns: {
          name: "Name",
          taker: "Taker Fee",
          maker: "Maker Fee",
          activeSince: "Active Since"
        },
        items: {
          bybit: {
            name: "Bybit",
            logo: "/images/markets/bybit.png",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2018"
          },
          mexc: {
            name: "Mexc",
            logo: "/images/markets/mexc.jpeg",
            taker: "0.0%",
            maker: "0.0%",
            activeSince: "2018"
          },
          kucoin: {
            name: "Kucoin",
            logo: "/images/markets/kucoin.png",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2017"
          },
          gateio: {
            name: "Gateio",
            logo: "/images/markets/gate.jpeg",
            taker: "0.2%",
            maker: "0.2%",
            activeSince: "2013"
          },
          bitget: {
            name: "Bitget",
            logo: "/images/markets/bitget.jpeg",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2018"
          },
          huobi: {
            name: "Huobi",
            logo: "/images/markets/htx.png",
            taker: "0.2%",
            maker: "0.2%",
            activeSince: "2013"
          },
          okx: {
            name: "Okx",
            logo: "/images/markets/okx.png",
            taker: "0.1%",
            maker: "0.08%",
            activeSince: "2017"
          },
          bingx: {
            name: "BingX",
            logo: "/images/markets/bingx.jpeg",
            taker: "0.020%",
            maker: "0.045%",
            activeSince: "2018"
          },
          binance: {
            name: "Binance",
            logo: "/images/markets/binance.jpeg",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2017"
          },
          bitmart: {
            name: "BitMart",
            logo: "/images/markets/bitmart.png",
            taker: "0.06%",
            maker: "0.04%",
            activeSince: "2017"
          },
          ourbit: {
            name: "Ourbit",
            logo: "/images/markets/ourbit.png",
            taker: "0.04%",
            maker: "0.02%",
            activeSince: "2018"
          },
          hyperliquid: {
            name: "Hyperliquid",
            logo: "/images/markets/hyperliquid.png",
            taker: "0.25%",
            maker: "0.2%",
            activeSince: "2022"
          },
          lbank: {
            name: "LBank",
            logo: "/images/markets/lbank.png",
            taker: "0.2%",
            maker: "0.2%",
            activeSince: "2015"
          },
          aster: {
            name: "Aster",
            logo: "/images/markets/aster.png",
            taker: "0.05%",
            maker: "0.02%",
            activeSince: "2023"
          },
          xt: {
            name: "XT",
            logo: "/images/markets/xtcom.png",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2017"
          },
          weex: {
            name: "WEEX",
            logo: "/images/markets/weex.png",
            taker: "0.06%",
            maker: "0.02%",
            activeSince: "2021"
          },
          phemex: {
            name: "Phemex",
            logo: "/images/markets/phemex.png",
            taker: "0.06%",
            maker: "0.01%",
            activeSince: "2019"
          },
          coinex: {
            name: "CoinEx",
            logo: "/images/markets/coinex.jpeg",
            taker: "0.1%",
            maker: "0.1%",
            activeSince: "2017"
          },
          binancealpha: {
            name: "Binance Alpha",
            logo: "/images/markets/binance.jpeg",
            taker: "1.0%",
            maker: "1.0%",
            activeSince: "2024"
          }
          }
        },
      fundingIs: {
        title: "🚀️ Funding Arbitrage: How to Earn Without Risk or Complex Strategies",
        subtitle: "https://t.me/fundingradar_official",

        intro: "✨ What is funding arbitrage and why is it profitable?",
        paragraph1: "Exploring financial markets often leads to the emergence of innovative investment methods that not only increase capital but also ensure its stability and reliability. One such method is futures (funding) arbitrage. In this article, we will look at what funding is, how it works, and how you can use it to secure a stable passive income.",
        paragraph2: "In this guide, we will go over the trading strategy using the Funding Bot, learn what funding is, understand the strategy, and examine several examples for entering any pair.",
        paragraph3: "The strategy of earning on inter-exchange funding arbitrage is one of the most profitable trading strategies in the cryptocurrency market. It is based on profiting from the difference in funding rates between different exchanges, as well as from exchange rate differences.",
        paragraph4: "Funding is a regular payment between traders trading perpetual futures. Exchanges use this mechanism to maintain balance between longs and shorts. Funding arbitrage allows you to profit from differences in funding rates between different exchanges or between spot and futures markets.",
        paragraph5: "The main advantage of this strategy is the absence of market risk. Unlike coin price speculation, you earn not from price growth or decline, but from the difference in payouts between exchanges.",

        howItWorks: "🔄 How does funding arbitrage work?",
        steps: [
          "Find a pair – the difference between funding rates on different exchanges.",
          "Open two opposite positions: a buy (long) on one exchange and a sell (short) on the other.",
          "Earn passive income from funding rate accruals."
        ],

        exampleTitle: "📈 Example",
        exampleSteps: [
          "Exchange A has a funding rate of -0.7% (shorts pay longs).",
          "Exchange B has a funding rate of +0.06% (longs pay shorts).",
          "We buy the asset on Exchange A and short it on Exchange B.",
          "We get a funding rate difference of +0.76% every 8 hours!"
        ],

        whyWorks: "💪 Why does this actually work?",
        whyPoints: [
          "No dependence on the asset price – even if the price changes, your income remains stable since the positions offset each other.",
          "Passive income – after opening positions, you simply wait for funding payments.",
          "Minimal risks – no need to predict market direction."
        ],
                
        sectionPractice: "Let’s move on to practice!",
        sectionPracticeText: "Here’s what a funding rate looks like on an exchange:",
        sectionPracticeImg: "/images/funding/funding-rate-example.png",
        sectionPracticeCaption: "Example of funding rate display on an exchange",

        sectionFundingRate: "Funding Rate",
        sectionFundingRateText: "On a trading platform, it is assumed that the price of the underlying asset and the futures contract should be identical. To maintain this, the funding rate was introduced. If the price deviates significantly, the funding rate increases, opening opportunities for arbitrage. This helps balance long and short positions so that the futures price matches the current price. Funding is paid every 8 hours, but it requires an open position at the time of calculation. You can hold the position for all 8 hours or open it a minute before the payout—it doesn’t matter. You’ll receive the payment anyway. On most exchanges, settlements occur at 03:00, 11:00, and 19:00, but on the KuCoin platform – at 07:00, 15:00, and 23:00, which can also be used for operations.",

        fundingTime: "Funding Settlement Time",
        fundingTimeText: "Each trading pair has minimum and maximum funding rates. If an exchange needs to move the futures price in a certain direction but the funding rate limits prevent it from doing so quickly enough, exchanges start reducing the payout intervals from 8 hours to 4, 2, or even 1 hour. We will also take advantage of this opportunity.",
        fundingTimeImg: "/images/funding/funding-times.png",
        fundingTimeCaption: "Funding settlement time",

        payoutTitle: "How is funding paid?",
        payoutText: "Let’s look at an example: suppose one exchange offers a funding rate of +1%, while another offers -1%. An investor can use this difference by opening a short position on the exchange with the higher rate and a long position on the one with the lower rate. The difference between the rates turns into additional profit.",
        payoutImg: "/images/funding/funding-paids.png",
        payoutCaption: "Funding payouts",

        payoutNote: "To clarify, if the funding rate is positive, +1%, the exchange pays +1% to short traders, and long traders have -1%. Conversely, if funding is negative, -1%, the exchange pays +1% to long traders, and short traders have -1%.",
                
        typesFunding: "Different types of funding may have the following features",
        fundingTypes: [
          "✅ Floating funding: The rate changes depending on current market conditions.",
          "✅ Fixed funding: The current rate remains unchanged but may change in the next period."
        ],
        fundingTypesNote: "For example, the KuCoin exchange uses fixed funding, while on other platforms the rate may be floating, i.e. changing depending on the current market situation.",
        
        hedgeTitle: "What is Hedging?",
        hedgeText: "Hedging is a risk management strategy used in financial markets. It involves using specific instruments or operations to reduce potential losses associated with asset price changes or other risk factors.",
        hedgeText2: "In the context of cryptocurrency trading, hedging can be used to protect against price fluctuations of cryptocurrencies. For example, a trader can simultaneously open two positions: a long (buy) position and a short (sell) position on the same coin to reduce potential losses in case of an unfavorable market movement.",
        hedgeText3: "In short: hedging means opening two positions in opposite directions simultaneously. We simply insure our assets against any possible fluctuations.",

        arbitrageTypes: "🔄 Types of Arbitrage",
        arbitrageText: "Arbitrage is a strategy in which an investor seeks to profit from price or rate differences between various financial instruments. Here are two main types of arbitrage that we will consider:",
        arbitrageList: [
          "Futures – Futures: An investor buys a futures contract for an asset on one exchange and simultaneously sells a futures contract for the same asset on another exchange. The difference between funding rates and prices becomes the source of profit.",
          "Spot – Futures: An investor buys an asset on the spot market (immediate delivery and payment) and simultaneously sells a futures contract for the same asset. We also earn from funding payments on one exchange and from price differences."
        ],
        arbitrageText2: "The goal of arbitrage is to profit from differences in prices or rates between various financial instruments, and sometimes from both opportunities simultaneously. Here’s how profit based on price difference looks:",
        arbitrageImg3: "/images/funding/profit-course.png",
        arbitrageCaption3: "Profit from price difference",
        arbitrageText3: "Let’s look at an example of arbitrage between the spot market (where the asset is bought or sold immediately) and the futures market (where deals are made for the future at a fixed price).",
        arbitrageText4: "Suppose we have an asset that we bought on the spot market. At the same time, we sold a futures contract for that same asset. When the asset prices on the spot and futures markets equalize, we can close our positions and take profit.",
        arbitrageText5: "We can also earn additional profit from funding payments if the funding rate is positive. Therefore, when prices align and we receive funding payments, this may be a good moment to close our positions and maximize profit. We can hold our positions for several days or weeks if the funding payout satisfies us.",

        priceDifferenceTitle: "📊 Let’s Look More Closely at Price Differences",
        priceDifferenceText: "In addition to funding rate arbitrage, we must pay attention to the price difference between assets. This will be our main source of profit!",

        priceDifferenceExampleText2: "Example (entry spread 1%)",
        priceDifferenceList2: [
          "On Exchange A, bitcoin costs $50,000 (spot).",
          "On Exchange B, bitcoin costs $50,500 (futures).",
          "If we buy one bitcoin on Exchange A at the price of $50,000,",
          "On Exchange B, we open a short position for one bitcoin as well.",
          "Then, when bitcoin on Exchange A is worth the same as on Exchange B, we will earn from the price difference between the assets!",
          "Let’s imagine that the price on both exchanges becomes $50,250 after we opened our positions. It turns out that on Exchange A we earned $250 since our spot coin became more expensive, and on Exchange B we also earned $250 since we opened a short position and the price went down. As a result, we will earn $500 if we entered around $50,000 per exchange — entering at an entry spread of 1% and exiting at an exit spread of 0%."
        ],

        priceDifferenceNote: "You can use any deposit amount (even $10, $50, $200, $1000, $10,000) as long as the coin has liquidity.",
        priceDifferenceNote2: "This is what earning on exchange rate or price differences between assets means!",

        botConceptsText: "Our bot has two important concepts. They are essential and among the main tools for making a profit. We will use them later.",
        botConceptsList: [
          "Entry spread: Shows the difference between prices on two exchanges if we were just entering a pair (i.e., buying on one exchange and shorting on the other). If it’s positive, prices diverge in a favorable direction for us; if negative, the entry spread is less profitable. We need to catch the moment when it’s as positive as possible!",
          "Exit spread: Shows the difference between prices on two exchanges if we were exiting a pair (i.e., selling coins on spot and closing the short on the other exchange). If it becomes more negative than the entry spread we entered at, we make a profit!"
        ],

        priceArbitrageStrategyTitle: "Price Difference Arbitrage Strategy",
        priceArbitrageStrategyText: "Our main strategy is to analyze listings on exchanges and find those where there are spot and futures markets (on the same or different exchanges). For those unfamiliar, a cryptocurrency listing is the process of adding a token to the list of assets available for trading on an exchange.",
        priceArbitrageStrategyText2: "After finding the desired listing, we must prepare and transfer our deposit in advance to the necessary exchange(s) and wait for the start of trading, so that mainly in the first hour of trading we can enter the pair with a profitable entry spread and exit with a profitable exit spread. Usually, during the first 5 minutes after a listing, there’s often a large price gap even between spot and futures on the same exchange. As soon as we see a positive entry spread, we wait — if it grows — or we enter if it’s between +0–50%, then wait for the prices to converge and exit when the exit spread is around -0–3%. However, it’s up to you to decide at what entry and exit spread levels to enter and exit as you find profitable.",
        priceArbitrageStrategyText3: "Sometimes the entry spread is not very large, say 3–5% on a listing, but you can still enter with a small entry and exit spread and make several cycles. Especially if trading on one exchange between spot and futures, prices will eventually converge anyway, and if we enter at a positive entry spread, it will eventually approach zero. Since prices fluctuate significantly on listings, we can enter, for example, at a 5% entry spread, wait, and exit at -5% to -2% exit spread. Often, entry and exit spreads fluctuate back and forth, allowing us to make over 10 (sometimes even 50+) profitable entries and exits per listing. Thus, after 10 cycles, you can earn around 25% of your deposit.",

        fundingArbitrageStrategyTitle: "Funding Rate Arbitrage Strategy",
        fundingArbitrageStrategyText: "The funding rate arbitrage strategy involves using hedging across different exchanges to insure the asset, while earning profit from interest rate differences and exchange rate disparities. Let’s look at an example trade suggested by the Funding Bot @funding_cryptoprojects_bot",
        fundingArbitrageStrategyText2: "At first, don’t pay attention to all the data in this pair—we will analyze them later. For now, it’s important to understand how our strategy works. Example:",
        fundingArbitrageStrategyImg3: "/images/funding/spread.jpg",
        fundingArbitrageStrategyCaption3: "Pair Example",

        exampleBundleText: "In this example, we see a pair provided by the bot between Bitget and Mexc exchanges. What’s remarkable about this pair?",
        exampleBundleText2: "We see that the bot suggests buying long on Bitget and shorting on Mexc, allowing us to earn 0.49% from funding, since on Bitget it’s -2% and on Mexc -1.51%. But that’s not the most important part!",
        exampleBundleText3: "In this pair, you need to pay attention to the entry spread — it’s 5.13%, which is quite high! Since entry and exit always tend toward zero, we can earn 5% on this pair.",
        exampleBundleText4: "But why is this coin different from others, and why is it worth entering it, given that there are other coins with high entry spreads?",
        exampleBundleText5: "It’s necessary to analyze what this coin is, when it was listed on exchanges, its liquidity, and when deposits and withdrawals will open between exchanges for this coin. After analysis, we can see that this coin appeared a few hours ago on major exchanges and has high liquidity, meaning deposits and withdrawals between exchanges will most likely open the next day around 14:00 MSK. If we enter this pair and wait until deposits open so arbitrageurs can equalize prices, the entry and exit spreads will be close to zero! This always happens when deposits and withdrawals open on popular coins. Then we’ll close our pair with an exit spread of 0% or even less and make a solid profit!",
        exampleBundleText6: "We’ll also receive funding payouts on this pair, which adds a small passive income for us.",
        exampleBundleText7: "Now we need to learn how to correctly enter a pair and what pitfalls to watch out for on different exchanges.",
        
        howToEnterBundlesTitle: "How to Enter Bundles?",
        howToEnterBundlesText: "First, you need to click the \"Chart\" button under the bot's message about the found bundle (or click the Info button and manually enter the coin, exchange, and select futures/futures or spot/futures).",
        howToEnterBundlesText2: "We have a web version for tracking entry and exit spreads in real time! Thanks to this, we can see how the entry and exit move up and down, allowing us to accurately enter with the desired entry spread and exit with the current exit spread! The main thing is to open and close positions on both exchanges simultaneously — it’s quite easy, no special dexterity is needed. Below you can see an example of the entry and exit spread for this coin on the next day, when withdrawals on exchanges became open, making entry and exit 0%!",

        fundingArbitrageStrategyImg3: "/images/funding/web-version.jpg",
        fundingArbitrageStrategyCaption3: "Web Version",

        webVersionText: "If we see on the chart that the entry spread is still high at 5%, we can enter this bundle and wait until the exit spread becomes 0% or even less, and then exit the bundle! Sometimes, during listings, you can make many such cycles, and without the web version, you won’t be able to react instantly to entry and exit increases or decreases, since they often change very quickly.",

        preparationText: "So, we’ve found a coin, it suits us, we’ve opened the chart, and we’re monitoring the entry. Now we need to prepare to enter the bundle!",
        preparationText2: "To do this, we check our exchange balances, select market orders (market price) for buying and opening positions, and check how many coins we can buy in total. Suppose we can buy about 10,000 coins — then we need to prepare in advance.",
        preparationText3: "Open two browser tabs with the exchanges and selected coins. First, set leverage to x1 on both exchanges (if entering both long and short) — this is mandatory for beginners. Then go to the exchange where we want to buy (or go long) and at market price choose around 70–80% of our deposit (so in case of price fluctuations, we still have enough balance to enter the bundle, since coin prices on both exchanges move up and down). Suppose we choose 8,000 coins on the first exchange and 8,000 coins on the second at market price. Then click Open Long on one exchange and Open Short on the other. You’ll see confirmation windows (almost all exchanges have this). Then we watch the chart and wait for a good entry moment! As soon as we’re satisfied with the entry spread, we click Open Long, quickly switch to the second exchange tab, click Open Short, and that’s it — we’re in the bundle! To exit, do the same: switch to closing positions, select 100% of your coins already in positions, and click Close Long on one exchange and Close Short on the other. Wait for a favorable exit spread and close positions! There’s one lifehack to quickly switch between exchange tabs!",

        quickSwitchText: "To quickly open or close positions simultaneously, open, for example, Bitget as the first exchange and Mexc as the second. On both exchanges, the confirmation window for entering the bundle should already be open in the center of the screen. Arrange Bitget on the left (first tab) and Mexc as the second tab. In most browsers, there are keyboard shortcuts ctrl+1 and ctrl+2 — allowing you to switch tabs with one hand and click with the mouse with the other! Simply click Open Long with the left mouse button, then immediately press ctrl+2 to switch to the second tab, and click Open Short — saving time by not manually selecting the tab at the top! Before entering bundles, check if this keyboard shortcut works for you.",

        examplesTitle: "Let’s Look at a Few Examples",
        examplesText: "Let’s say for the coin HBAR between KuCoin and Bybit — how to enter the bundle: on this exchange we selected leverage x1, market, selected part of the balance (not the entire balance), and then click Sell/Short. Be sure to select the amount in coins, not in dollars!",
        examplesArbitrageStrategyImg2: "/images/funding/hbar.png",
        examplesArbitrageStrategyCaption2: "Opening an HBAR Short on KuCoin",

        hbarShortText: "I do not recommend beginners use leverage higher than x1, since both losses and profits can multiply greatly. I usually use x1–x3 leverage, depending on the coin; x3 very rarely, because if the coin price fluctuates strongly, liquidation may occur.",
        hbarLongText: "On the other exchange, we do the same, but open a long position — choose Market, set order type to Quantity (to enter the amount of coins, not dollars), leverage x1, and click Buy Long.",

        examplesArbitrageStrategyImg3: "/images/funding/long.png",
        examplesArbitrageStrategyCaption3: "Opening an HBAR Long on Bybit",
        hbarLongText2: "Now we have entered the same number of coins and wait for the exit spread to reach around 0%, as well as funding payments. Or, without waiting for funding, if entry and exit spreads frequently swing to high positive values and back to around zero, we can make cycles and earn on price differences!",
        hbarLongText3: "If we leave the bundle overnight or for a long period (unattended), it’s necessary to set Take-Profit and Stop-Loss — this will help close trades more accurately with almost no loss in case of liquidation. This is important.",

        risksTitle: "Risks",
        risksText: "In fact, the risks here are small:",
        risksList: [
          "Price divergence: You entered a little-known (red) coin, and prices on exchanges suddenly diverged in opposite directions, causing liquidation of your positions (that’s why we use Stop-Loss and Take-Profit). This risk exists but is very small, and if we have stop-loss and take-profit set, losses will be minimal. There’s no risk of losing the entire balance.",
          "If we entered a spot/futures pair, our only risk is if the price rises sharply — since we opened a short. If the price falls, there’s no liquidation risk! Therefore, spot/futures bundles are safer, and their prices differ more significantly between exchanges, often giving a high entry spread.",
          "Minor losses due to funding rate changes: It’s possible that the asset price may move unfavorably and the funding rate may change. However, such cases are extremely rare, and losses usually remain insignificant.",
          "Need for analysis and thought: There’s no need to rush into a trade. Everything can be carefully analyzed and considered. Since we enter long on one exchange and short on another simultaneously, price movements don’t affect us. However, if we want to profit from entry/exit spread differences, we should act quickly, as high spreads usually don’t last long."
        ],

        automationTitle: "🌟 How to Automate Arbitrage and Save Time?",
        automationText: "Constantly monitoring funding rates manually is inefficient. Prices change, bundles appear and disappear, and manually finding the best option is difficult.",
        automationText2: "🌟 Our bot FundingRadar solves these problems for you!",

        automationList: [
          "Analyzes thousands of bundles between exchanges in real time.",
          "Provides the best options with profit calculation.",
          "Allows filtering bundles by funding rate and entry spread.",
          "You can activate monitoring and get notified about a new profitable bundle.",
          "Free 6-hour trial period!",
          "Referral system — earn 20% from each payment made by your referral!"
        ],

        webVersionTitle: "🌐 Web Version: Interactive Charts and Convenient Analysis",
        webVersionText: "For convenience, we’ve developed a web version of the bot. It includes:",
        webVersionList: [
          "✅ Interactive real-time charts of entry and exit spreads.",
          "✅ Historical charts of entry and exit spreads for each coin.",
          "✅ Profitability calculation considering order book volume.",
          "✅ Flexible analysis depth selection (x3 or x5 values).",
          "✅ A section with subscription info and invited referrals.",
          "✅ A section with helpful articles and answers to popular questions."
        ],
        webVersionNote: "Now you don’t need to be a professional trader — everything is calculated for you!",

        profitSection: "profit from price difference",
        conclusion: "Conclusion",
        conclusionText: "To get even more information, follow our Telegram channel — we sometimes post free bundles there, and you can also find results of our subscribers’ arbitrage trades. We also have a private subscriber chat where we discuss all bundles and discover new ones! To join, you need to purchase a subscription and contact support. Wishing everyone successful bundles and lots of dollars 💲💲💲",
        telegram: "Our Telegram channel: FundingRadar",
        bot: "Funding Bot",
        bot_url: "https://t.me/funding_cryptoprojects_bot",
        bot_image: "/images/funding/fbot.jpg"

      },
      aboutBot: {
        title: "Instructions for using the funding arbitrage bot",
        subtitle: "https://t.me/fundingradar_official",
        intro: "✨ Introduction",
        paragraph1: "This bot is designed to simplify the process of funding arbitrage between various cryptocurrency exchanges. With its help, you can track profitable pairs, receive notifications, and analyze data to make informed trading decisions.",
        section1: {
          title: "Main sections of the bot",
          list: [
            "🔄  Futures: Displays all available pairs between futures contracts on different exchanges.",
            "🔀  Spot/Futures: Shows pairs between spot and futures markets.",
            "🔴  Blacklist: Allows you to add coins to the blacklist.",
            "🏦 Exchanges: A list of all exchanges integrated into the bot. You can disable unnecessary exchanges at your discretion.",
            "🔔  Monitoring: Allows you to set threshold values for funding or entry spread. When these values are exceeded, the bot will automatically send you a notification."
          ],
          img: "/images/aboutbot/sections-tg.png",
          caption: "Main sections"
        },
        section2: {
          title: "Terminology and metrics 📊",
          text: "Under the name of each exchange, you can see data about the current spread on them.",
          list: [
            "Current: Shows the current funding rate on this exchange.",
            "Forecast: Available only on KuCoin; shows the expected next funding rate.",
            "Aims: Shows the funding rate the current one is aiming for, so you can determine whether it is rising or decreasing.",
            "Hours: Indicates the frequency of funding payments; exchanges sometimes reduce it to 4, 2, or even 1 hour if necessary, which allows receiving more frequent payments on one of the exchanges.",
            "Accumulated: The total funding rate for the selected period (1, 3, 7, or 30 days)."
          ],
          img: "/images/aboutbot/terminology.png",
          caption: "Pair data"
        },
        section3: {
          title: "Spread",
          text: "Below the data for each exchange there is a \"💰 Spread:\".",
          list: [
            "Current: Shows the profit from funding between two exchanges. Keep in mind that this profit comes from half of your total amount.",
            "Fee: The total taker fee, assuming that the same number of coins is held on each exchange.",
            "Entry spread: If you enter at a negative spread — you need to exit at an even more negative one. If you enter at a positive spread — you need to exit at a less positive, zero, or negative one. When entering a trade, you should consider the 'Entry spread' — the higher it is, the better; before exiting the trade, you should look at the 'Exit spread'.",
            "Exit spread: It should be smaller (more negative) than your entry spread to profit from the price difference. That is, the exit spread should be more negative than your entry spread.",
            "Accumulated: Shows the accumulated funding rate between two exchanges (futures/futures). If it’s spot/futures, then for one exchange."
          ],
          img: "/images/aboutbot/spread.png",
          caption: "Spread"
        },
        section4: {
          title: "Chart",
          paragraph: "When you click on the chart or the \"Info\" button to the left of the message input, you are redirected to our web version, where the chart of entry and exit spread for the selected pair is displayed in real time. The order book with volume in USD $ is also available there.",
          img: "/images/aboutbot/graphic.png",
          caption: "\"Chart\" button"
        },
        section5: {
          title: "Web version",
          text2: "In the Trading tab:",
          list: [
            "At the very top, you can select the coin, type \"Futures/Futures\" or \"Spot/Futures\", as well as the exchanges between which you want to monitor the pair.",
            "Just below are the settings — you can specify the volume (in USD $) and click the button to the right so that the blue circle lights up. Then, the entry and exit spreads on the chart will be displayed taking into account the calculated order book volume. For example, by entering $1000, the chart will show what the entry and exit spread would be if you entered a pair with $1000 on each exchange. This helps you easily determine whether there is enough liquidity in the current pair for the chosen volume. The specified volume applies separately to each exchange! That is, if you set $500, it means that on one exchange you will buy for $500 and on the other you will short for $500. Pressing the button again will turn it gray, meaning the calculation considering order book volume is disabled.",
            "To the right of the volume input and toggle button, there are two more buttons. The \"3\" (\"5\") button means order book depth. If depth \"3\" is not enough, click it and the depth will change to \"5\".",
            "The first chart below the settings displays the current entry and exit spread along with the order book, allowing you to track entry and exit points for each pair of interest in real time and see whether there’s enough liquidity in the books, and what volume can be entered without significant slippage.",
            "At the top left of the chart, there is a \"⚙️ Settings\" button to open additional settings for entering the prices at which you entered the pair, for automatic calculation of entry and exit spreads, and displaying them on the chart as lines for convenience.",
            "After clicking on \"⚙️ Settings\", a \"Bell\" icon also becomes available. By setting threshold values, you’ll hear a ring sound and won’t miss an entry or exit opportunity.",
            "The \"+\" button at the top left of the chart allows you to open multiple bot instances on PC or mobile, useful if you want to track several charts at once."
          ],
          list2: [
            "The second chart below shows the historical entry and exit spread for every 1 minute over the past 48 hours. This chart is convenient for analyzing what the entry and exit spread of a particular coin was to determine the right moment to enter — it helps you understand when it’s best to enter or exit a pair. (At the top left there is a \"Magnifier\" button to enable zooming and panning on the chart).",
            "To the right of the charts, on the Y-axis, the entry and exit spread are displayed as percentages. At the bottom of the charts, the X-axis shows time, and in the lower chart, hours are displayed.",
            "At the bottom of the web version, there are tabs: \"Trading\", \"Spreads\", \"Subscription\", \"Information\". The first two are the main ones where trading takes place."
          ],
          img: "/images/aboutbot/web-version.png",
          caption: "Web version",
          img3: "/images/aboutbot/history-graph.png",
          caption3: "Spread history chart"
        },
        section6: {
          title: "In the Subscription tab",
          list: [
            "You can view all necessary information about your subscription status, how many days or hours remain, as well as your referral link (you will receive 20% from each subscription payment made by your referral). Below, all your referrals are listed, including whether they tested the bot or already purchased a subscription."
          ],
          img: "/images/aboutbot/subscribe.png",
          caption: "Subscription tab",
        },
        section7: {
          title: "In the Information tab",
          paragraph: "You can find useful links to our resources, including answers to frequently asked questions.",
          img: "/images/aboutbot/info.png",
          caption: "Information",
        },
        section8: {
          title: "Usage recommendations 💡",
          paragraph: "For a successful trade, you must calculate everything in advance and simultaneously buy coins with a market order for the same amount on both exchanges. For convenience, you can open two browser tabs and switch between them using ctrl+1 and ctrl+2 if the tabs are in the first and second positions from the left. This makes it easier to switch and confirm the buy or sell orders with your mouse on both exchanges at once by positioning it in the center of the screen beforehand for confirmation."
        },
        section9: {
          title: "In the Spreads tab",
          list: [
            "You can conveniently view current spreads with auto-refresh every 4 seconds.",
            "You can choose sorting by \"Entry\" or by \"Funding\", as well as \"Entry > 0\", enable or disable auto-refresh (\"Auto\"), choose how many spreads to display per page — \"5\", \"7\", \"10\", \"20\" — and most usefully, the Bell icon."
          ],
          list2: [
            "By clicking the Bell icon, you can set thresholds for entry and exit. When one of the spreads (futures/futures or spot/futures) crosses the threshold, you’ll hear a ring and can react in time. This is very convenient — you can even step away from your PC or phone and still not miss a spread thanks to the sound alert.",
            "You can choose sorting by \"Entry\" or \"Funding\", as well as \"Entry > 0\", and enable or disable auto-refresh (\"Auto\")."
          ],
          img: "/images/aboutbot/spreads-web.png",
          caption: "Spreads tab",
          img3: "/images/aboutbot/colocol-web.png",
          caption3: "Bell",
        },
        textfuter: "For large amounts (depending on the order book, approximately from $2000), it’s better to enter in parts to avoid slippage (to prevent losses on the rate). You can use leverage (for example, 4x) when trading futures/futures to increase profit 4 times. Using leverage is highly discouraged for beginners on their first pairs."
      },

      faq: {
        title: "Frequently Asked Questions",
        subtitle: "Answers to common questions about subscription, payments and how the bot works.",
        q1: "How much does the subscription cost?",
        a1: "The subscription costs 40 USDT per month (30 days) or 75 USDT for 3 months (90 days).",
        q2: "How can I test the bot?",
        a2: "To test the bot and verify its operation, please contact our support team for trial access.",
        q3: "How do I pay for a subscription?",
        a3: "To pay, transfer funds to the payment details provided in the bot. If that method doesn't work, contact support for alternatives.",
        q4: "Is funding arbitrage still relevant?",
        a4: "Yes — funding arbitrage remains relevant. With the right approach and market analysis, it’s possible to profit from rate differences.",
        q5: "Which exchanges are supported?",
        a5: "Currently supported (16 exchanges): Bybit, Mexc, Kucoin, Gateio, Bitget, Huobi, Okx, BingX, Binance, BitMart, Ourbit, Hyperliquid, LBank, Aster, XT, CoinEx.",
        q6: "How do I earn using the bot?",
        a6: "Read our guides and the detailed bot instructions — they describe setup steps and strategies. Support will help if needed.",
        q7: "How much can I earn?",
        a7: "Exact profit cannot be predicted — it depends on market conditions, strategies and risk. Historical ranges roughly from 30% to 100%+ per month.",
        q8: "Can I lose my entire deposit?",
        a8: "While theoretically possible, funding arbitrage is relatively low-risk with proper risk management. Typical loss on a single pair is around 0–5% of the deposit.",
        q9: "There is no answer to my question",
        a9: "Contact support to get an answer to your question.",
        still_need_help: "Still need help?",
        contact_support: "Contact support"
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang,
  fallbackLng: "ru",
  interpolation: { escapeValue: false }
});

export default i18n;
